module.exports = __webpack_public_path__ + "Flama-BlackItalic.woff2?7ea0028f99abdc81293afcfe707a9d5d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BlackItalic.woff2
// module id = 908
// module chunks = 0